import styled from 'styled-components';
import {dFlex, dFlexColumn, dFlexBetween, flexRowReverse, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {desktopMedia, WHITE} from '../../../../../../globalVariables/GlobalVariables';

export const card = styled.div<{ area?: string }>`
    grid-area: ${p => p.area};
    ${dFlexColumn}
    gap: var(--space-sm);
    padding: var(--space-md);
    background: ${p => p.theme.isDarkMode ? 'rgba(255,255,255,0.06)' : 'var(--color-bg-base)'};
    border: 1px solid ${p => p.theme.isDarkMode ? 'rgba(255,255,255,0.15)' : 'var(--color-border-subtle)'};
    border-radius: var(--radius-sm);
    text-align: start;
`;

export const cardHeader = styled.div`
    ${dFlexBetween}
    gap: var(--space-sm);
    width: 100%;
`;

export const titleGroup = styled.div`
    ${dFlex}
    ${flexRowReverse}
    ${alignCenter}
    gap: var(--space-md);
    ${desktopMedia}{
        flex-direction: row;
    }
`;

export const cardTitle = styled.h3`
    margin: 0; /* reset browser default h3 margin */
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
    white-space: nowrap;
`;

export const iconBox = styled.div`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    ${dFlex}
`;

export const value = styled.div`
    font-size: 40px; /* Figma font-size/h1 */
    font-weight: var(--font-weight-semibold);
    line-height: 1.1;
    ${desktopMedia}{
        font-size: var(--font-size-heading-page);
        line-height: 1.15;
    }
`;

export const splitRow = styled.div<{ alignEnd?: boolean }>`
    ${dFlexColumn}
    gap: var(--space-md);
    width: 100%;
    ${desktopMedia}{
        flex-direction: row;
        align-items: ${p => p.alignEnd ? 'flex-end' : 'flex-start'};
        justify-content: space-between;
    }
`;

export const valueBlock = styled.div`
    ${dFlexColumn}
    gap: var(--space-xs);
    text-align: start;
`;

export const footer = styled.div`
    font-size: var(--font-size-caption);
    line-height: 1.33;
    color: ${p => p.theme.isDarkMode ? WHITE : 'var(--color-text-default)'};
`;
